module.exports = __webpack_public_path__ + "img/Logo_IC_Outubro_Rosa_semfundo.f068ad30.svg";